export default "__VITE_ASSET__CgOmV8Xh__"